import React, { useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Button, Nav, Dropdown, Form, InputGroup } from "react-bootstrap";
import { CREATE_FORM_URL, CREATE_FORM_URL_LATEST } from "../../../Constant/api";
import { useFormDetails } from "../../../Constant/apiHooks";
import { authService } from "../../../Service/Axios";
import { PreviewForm } from "../../../Components/Modal";
import { paths } from "../../../Constant/paths";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const FormHeader = ({ rcvForm, dataForm, page, flag }) => {
  const { t } = useTranslation();

  const {
    customizeForm: {
      root,
      formDesign,
      formSetting: { root: formSettingRoot, generalSettings },
    },
  } = paths.formBuilder;

  const { pathname } = useLocation();
  const { formId } = useParams();

  const [show, setShow] = useState(false);

  const { formDetails, loading: formDetailsLoading } = useFormDetails(formId);

  const viewShow = () => {
    createFormAction("preview");
    toast.error("Only saved form is available here");
    setShow(true);
  };

  const createFormAction = async (data) => {
    const payload = {
      formId: formId ? formId : 5,
      formName: "",
      description: "",
      status: data,
      pages: page?.map((elem) => {
        return {
          ...elem,
          questions: dataForm,
        };
      }),
      mandatory: false,
    };

    const response = await authService(CREATE_FORM_URL_LATEST, "POST", payload);
    if (response) {
      rcvForm(response);
    }
  };

  const handleSaveForm = (e) => {
    e.preventDefault();
    // localStorage.removeItem("ID");
    createFormAction("save");
    toast.success("Saved Successfully!");
  };

  const history = useNavigate();

  const [linkURI, setlinkURI] = useState(
    `https://www.plutoedu.com/form/${formId}`
  );

  const handlelinkURI = (e) => {
    setopenCopy(!openCopy);
    navigator.clipboard.writeText(linkURI);
    toast.success("Copied Successfully!");
  };

  const [openCopy, setopenCopy] = useState(false);

  const handlePublished = () => {
    setopenCopy(!openCopy);
    createFormAction("Published");
    toast.success("Published Successfully!");
  };

  return (
    <div className="formeditor-header bg-white rounded-top d-flex justify-content-between align-items-center shadow-sm relative">
      <div className="formeditor-header-left d-flex">
        <div className="headereditor-title py-3 ps-3">
          <h3>{formDetails?.formName}</h3>
          <div className="headereditor-sub-title d-flex align-items-center">
            <i className="bx bx-folder bx-xs me-1"></i>{" "}
            {formDetails?.folderName}{" "}
          </div>
        </div>
      </div>
      <div className="formeditor-header-middle">
        <Nav className="parrent-tab nav-tabs d-flex justify-content-center p-1 rounded-1 gap-2">
          <Nav.Item className={pathname.includes(formDesign) ? "active" : ""}>
            <Nav.Link
              as={Link}
              to={`${root}/${formId}/${formDesign}`}
              className="rounded-1"
            >
              {t("common.button.fields")}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className={pathname.match(formSettingRoot) ? "active" : ""}>
            <Nav.Link
              as={Link}
              to={`${root}/${formId}/${formSettingRoot}`}
              className="rounded-1"
            >
              {t("common.button.formSetting")}
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </div>
      <div className="formeditor-header-right">
        <div className="d-flex justify-content-end align-items-center">
          {/* <div className="unduredo-btns d-flex align-items-center py-3">
            <Button variant="action btn-sm px-1">
              <i className="bx bx-undo bx-sm"></i>
            </Button>
            <Button variant="action btn-sm px-1">
              <i className="bx bx-redo bx-sm"></i>
            </Button>
          </div> */}
          {flag && (
            <div className="editor-action-btns ms-2 d-flex gap-2 align-items-center py-3 px-3">
              <Button variant="gray-light btn-sm bx-sm view-btn">
                <i className="bx bx-show-alt" onClick={viewShow}></i>
              </Button>
              <Button variant="gray-light btn-sm" onClick={handleSaveForm}>
                {t("common.button.save")}
              </Button>
              {/* <Button
              variant="primary btn-sm"
              onClick={() =>
                history(
                  `/auth/form-builder/application-form/${formId}`
                )
              }
            >
              Publish
            </Button> */}

              <div className="relative max-300">
                <Button variant="primary btn-sm" onClick={handlePublished}>
                  {t("common.button.publish")}
                </Button>

                {openCopy && (
                  <div className="p-3 border-0 dropdown-menu-custom shadow max-300">
                    <form className="">
                      <div className="mb-3">
                        <label className="form-label" for="getlink">
                          {t("common.label.getLink")}
                        </label>
                        <div className="gap-2 input-group">
                          <input
                            aria-label="Recipient's username"
                            aria-describedby="basic-addon2"
                            id="getlink"
                            className="rounded-1 form-control form-control-sm bg-grey-50 text-grey-700"
                            value={linkURI}
                          />
                          <button
                            type="button"
                            className="btn btn-dark rounded-1"
                            onClick={handlelinkURI}
                          >
                            {t("common.button.copy")}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                )}
              </div>

              <Dropdown className="max-300" autoClose="outside">
                {/* <Dropdown.Toggle
                variant="primary btn-sm remove-arrow"
                id="dropdown-basic"
              >
                Publish
              </Dropdown.Toggle> */}

                <Dropdown.Menu className="p-3 border-0 shadow">
                  <Form>
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="getlink">
                        {t("common.label.getLink")}
                      </Form.Label>
                      <InputGroup className="gap-2">
                        <Form.Control
                          value={linkURI}
                          aria-label="Recipient's username"
                          aria-describedby="basic-addon2"
                          id="getlink"
                          className="rounded-1"
                        />
                        <Button variant="dark rounded-1">
                          {t("common.button.copy")}
                        </Button>
                      </InputGroup>
                    </Form.Group>
                  </Form>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}
        </div>
      </div>
      {show && <PreviewForm show={show} setShow={setShow} formId={formId} />}
    </div>
  );
};

export default FormHeader;
